import { combineReducers } from "redux"

const iniState=""
const postReducer =(state=iniState, action)=>{
    return state
}

export default combineReducers({postReducer})